import { CustomDropdown } from "./Dropdown";
import { ControlsDropdownContextProvider } from "./context";

export const ControlsDropdown = () => (
  <ControlsDropdownContextProvider>
    <CustomDropdown />
  </ControlsDropdownContextProvider>
);
